<div class="layout-wrapper bk-main" [ngClass]="containerClass">
    <app-topbar></app-topbar>
    <div class="layout-sidebar">
        <app-sidebar></app-sidebar>
    </div>
    <div class="layout-main-container">
        <div class="layout-main">
            <!-- WhatsApp desconectado (AF327): fijo, en todas las pantallas -->
            <app-wsp-disconnected-banner></app-wsp-disconnected-banner>
            <app-no-messages-banner></app-no-messages-banner>
            <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
    </div>
    <app-config></app-config>
    <div class="layout-mask"></div>
</div>
